import { LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface PremiumMetricCardProps {
  title: string;
  value: string | number;
  change?: number;
  icon: LucideIcon;
  gradient: string;
  isLoading?: boolean;
}

export const PremiumMetricCard = ({ 
  title, 
  value, 
  change, 
  icon: Icon, 
  gradient,
  isLoading 
}: PremiumMetricCardProps) => {
  if (isLoading) {
    return (
      <Card className="premium-card animate-pulse">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div className="space-y-3">
              <div className="h-4 bg-muted rounded w-20"></div>
              <div className="h-8 bg-muted rounded w-24"></div>
            </div>
            <div className="h-12 w-12 bg-muted rounded-lg"></div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="premium-card animate-slide-up group">
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-3xl font-bold text-foreground">{value}</p>
            {change !== undefined && (
              <div className={`flex items-center text-sm font-medium ${
                change >= 0 ? 'text-emerald-600' : 'text-red-500'
              }`}>
                <span className="mr-1">{change >= 0 ? '↗' : '↙'}</span>
                {Math.abs(change)}%
              </div>
            )}
          </div>
          <div className={`p-3 rounded-xl ${gradient} group-hover:scale-110 transition-transform duration-300`}>
            <Icon className="h-6 w-6 text-white" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};